import { LOAD_SUTOCHNO_PILOT_SUCCESS, LOAD_SUTOCHNO_PILOT_START } from '../../actions/sutochnoPilot';
import { TReduxActions } from '../../types/redux';
import { ESutochnoPilotStatus, ISutochnoPilotState } from '../../types/sutochnoPilot';
import { defaultState } from './defaultState';

export function sutochnoPilotReducer(
  state: ISutochnoPilotState = defaultState,
  action: TReduxActions,
): ISutochnoPilotState {
  switch (action.type) {
    case LOAD_SUTOCHNO_PILOT_START: {
      return {
        ...state,
        status: ESutochnoPilotStatus.Loading,
      };
    }

    case LOAD_SUTOCHNO_PILOT_SUCCESS: {
      return {
        ...state,
        ...action.payload,
        status: ESutochnoPilotStatus.Success,
      };
    }

    default:
      return state;
  }
}
